import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import HospitalMap from './SubComponents/HospitalMap';
import HospitalList from './SubComponents/HospitalList';
import MyLocationCard from './SubComponents/Cards/MyLocationCard';
import FilterCard from './SubComponents/Cards/FilterCard';
import './Hospitals.css';

class Hospitals extends Component {
  state = {
    filterValue: null,
  }

  componentWillMount = () => {
    this.getLocation();
  }

  getLocation = () => {
    this.setState({ isLoading: true });
    if (window.navigator.geolocation) {
      const id = window.navigator.geolocation.getCurrentPosition(
        this.setLocationInState,
        this.showError,
      );
      this.setState({ id });
    }
  }

  changeMapCenter = (newCenter) => {
    const timeOut = this.state.zoom ? 400 : 0;
    this.setState({
      zoom: 15,
    });
    setTimeout(() => {
      this.setState({
        center: newCenter,
        zoom: 16,
      });
    }, timeOut);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  setLocationInState = (position) => {
    const location = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };
    this.setState({
      location,
      isLoading: false,
    });
    this.changeMapCenter(location);
  }

  updateFilter = ({ target: { value } }) => {
    this.setState({ filterValue: value });
  }

  showError = (error) => {
    let errorMessage;
    switch (error.code) {
      case error.PERMISSION_DENIED:
        errorMessage = 'Geen toegang om locatie te raadplegen.';
        break;
      case error.POSITION_UNAVAILABLE:
        errorMessage = 'Locatie informatie is niet beschikbaar.';
        break;
      case error.TIMEOUT:
        errorMessage = 'Opvragen locatie timed out.';
        break;
      default:
        errorMessage = 'Een onverwachte error is opgetreden.';
        break;
    }
    this.setState({ error: errorMessage, isLoading: false });
  }

  render() {
    const { filterValue, location } = this.state;
    return (
      <Grid stackable className="Hospitals">
        <Grid.Row columns={2}>
          <Grid.Column width={11}>
            <div className="Hospitals__MapContainers">
              <HospitalMap
                {...this.state}
                changeMapCenter={this.changeMapCenter}
                loadingMessage="Map laden"
              />
            </div>
          </Grid.Column>
          <Grid.Column width={5} className="Hospitals__SideBar">
            <MyLocationCard
              location={location}
              changeMapCenter={this.changeMapCenter}
            />
            <FilterCard
              filterValue={filterValue}
              updateFilter={this.updateFilter}
            />

            <HospitalList
              {...this.state}
              changeMapCenter={this.changeMapCenter}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default Hospitals;



// WEBPACK FOOTER //
// ./src/components/Hospitals/index.js